import script from "./Tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tag.vue?vue&type=script&lang=ts&setup=true"

import "./Tag.vue?vue&type=style&index=0&id=375c2172&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375c2172"]])

export default __exports__